export const bigBlackBorder = "3px solid black"
export const smallBlackBorder = "1px solid black"
export const mediumGrayBorder = "1px solid gray"

export enum BudgetTableMode {
  View = "view",
  Edit = "edit",
  Create = "create",
  Revision = "revision",
}
